import React, { useEffect, useRef, useState } from 'react';
import DataTable from 'react-data-table-component';
import moment from 'moment';
import { Button, Card, CardBody, CardFooter, CardHeader, Col, Row } from 'reactstrap';
import { hasPermission } from '../../../../../../../Helpers/Helpers';
import { PermissionConstants } from '../../../../../../../Helpers/Constants/permissions';
import { Constant } from '../../../../../../../Helpers/constant';
import CustomTable from '../../../../../../../Common/Table/Table';
import downloadImage from '../../../../../../../../assets/images/download.svg';

const Table = props => {
  console.log('props change', props);
  const [data, setData] = useState([]);
  const [bookingData, setBookingData] = useState([]);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    if (props?.data?.length > 0) {
      setBookingData(
        props?.data?.map(booking => {
          return { ...booking };
        }),
      );
    } else {
      setData([]);
    }
  }, [props?.data]);

  useEffect(() => {
    if (bookingData?.length > 0) {
      const fetchColumns = [
        {
          name: 'S.No',
          width: '90px',
          wrap: true,
          selector: row => row?.serialNumber,
        },
        {
          name: 'Booking Id',
          width: '140px',
          cell: row => (
            <span className="" style={{ color: '#3577f1' }}>
              {row?.booking_id}
            </span>
          ),
        },
        {
          name: 'Membership Id',
          width: '160px',
          cell: row => row?.membership_id,
        },
        {
          name: 'Full Name',
          width: '200px',
          cell: row => row?.name,
        },
        {
          name: 'Mobile No.',
          width: '140px',
          cell: row => row?.mobileNo,
        },

        {
          name: 'Email',
          width: '200px',
          cell: row => row?.email,
        },

        {
          name: 'Facility Name',
          width: '200px',
          cell: row => row?.facilityName,
        },

        {
          name: 'Partner',
          width: '200px',
          cell: row => row?.partnerName,
        },

        {
          name: 'Service',
          width: '200px',
          cell: row => row?.serviceName,
        },

        {
          name: 'Benefit Type',
          width: '160px',
          wrap: true,
          selector: row => row?.benefit_type,
        },
        {
          name: 'Booking Type',
          width: '190px',
          wrap: true,
          selector: row => row?.booking_type,
        },
        {
          name: 'Created At',
          width: '170px',
          wrap: true,
          selector: row => row?.created_at,
        },
        {
          name: 'Updated At',
          width: '170px',
          wrap: true,
          selector: row => row?.updated_at,
        },
        {
          name: 'Booking Status',
          width: '150px',
          cell: row => (
            <span
              className={`booking_status badge break-word bg-${
                Constant.BOOKING_STATUSES_V2.filter(status => status?.bookingStatus === row?.booking_status)[0]?.bgColor
              }`}
            >
              {row?.booking_status}
            </span>
          ),
        },
      ];
      setColumns(fetchColumns);

      setData(
        bookingData?.map((data, index) => {
          return {
            serialNumber: `${props?.pageNumber * Constant.TABLE_PAGE_SIZE + index + 1 - Constant.TABLE_PAGE_SIZE}.`,
            name: data?.user?.firstName || data?.user?.lastName ? `${data?.user?.firstName || ''} ${data?.user?.lastName || ''}` : 'NA',
            mobileNo: data?.user?.phoneNumber ? data?.user?.phoneNumber : 'NA',
            email: data?.user?.email ? data?.user?.email : 'NA',
            membership_id: data?.membership_id,
            facilityName: data?.booking_display?.benefitFacility?.name || 'NA',
            partnerName: data?.booking_display?.benefitPartner?.name || 'NA',
            serviceName: data?.booking_display?.displayName || 'NA',
            booking_id: data?.booking_id,
            benefit_type: data?.benefit_type,
            booking_type: data?.booking_type,
            booking_status: data?.booking_status,
            created_at: data?.created_at ? moment(new Date(`${data?.created_at}`)).format('DD-MM-YYYY, h:mm A') : 'NA',
            updated_at: data?.updated_at ? moment(new Date(`${data?.updated_at}`)).format('DD-MM-YYYY, h:mm A') : 'NA',
            originalData: data,
          };
        }),
      );
    } else {
      setData([]);
      setColumns([]);
    }
  }, [bookingData]);

  return (
    <>
      <Row>
        <Col xxl={12}>
          <Card>
            <CardHeader className="d-flex justify-content-end">
              <h4 className="card-title mb-0 flex-grow-1">Gamification Booking List</h4>

              {hasPermission(PermissionConstants?.ALL_PERMISSIONS?.CLIENT_DOWNLOAD_ACCESS) && props?.data?.length > 0 && (
                <Button onClick={props?.dumpDownload} className="download-dump-btn">
                  Download <img src={downloadImage} alt="Download" width="20" height="20" />
                </Button>
              )}

              {/* <Button>Download dump</Button> */}
            </CardHeader>

            <CardBody>
              <CustomTable
                columns={columns ?? []}
                data={data ?? []}
                totalCount={props.totalCount}
                limit={props.limit}
                handleRowsPerPageChange={props.handleRowsPerPageChange} // Allows rows-per-page customization
                currentPage={props.pageNumber}
                handlePageChange={props.handlePageChange}
                indexType={Constant.INDEX_TYPE.ONE_BASED}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Table;
